import { InjectionToken } from '@angular/core';

// Use this token to determine whether to include owner information in Brands/Manufacturers API requests
export const INCLUDE_OWNER = new InjectionToken<boolean>('INCLUDE_OWNER');
